import React from "react";
import { Link } from "react-router-dom";
import { Scales, ArrowLeft } from "@phosphor-icons/react";

const CONTACT = "hello@dftbdigital.com";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="space-y-6 max-w-2xl">
      <div>
        <Link
          to="/info"
          data-testid="terms-back"
          className="inline-flex items-center gap-1 text-xs font-mono-time uppercase tracking-widest text-[#7A828C] hover:text-[#000000]"
        >
          <ArrowLeft size={12} /> Back to info
        </Link>
        <div className="mt-2 flex items-center gap-2">
          <Scales size={20} className="text-[#000000]" weight="duotone" />
          <div className="font-mono-time text-xs uppercase text-[#7A828C] tracking-widest">Legal</div>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-1">Terms of Service</h1>
        <p className="text-xs text-[#7A828C] mt-1">Last updated: 19 May 2026</p>
      </div>

      <section className="text-sm text-[#5a5a5] leading-relaxed space-y-3">
        <p>
          These terms govern your use of the DFTB26 conference application (the &quot;App&quot;) provided by{" "}
          <strong>Don&apos;t Forget The Bubbles Ltd</strong> (&quot;DFTB&quot;, &quot;we&quot;, &quot;us&quot;).
          By creating an account or otherwise using the App you agree to these terms.
        </p>
      </section>

      <Block title="1. Eligibility">
        <p>
          The App is for delegates, speakers and staff of the DFTB26 conference. You must be 16 or older and provide
          accurate registration information.
        </p>
      </Block>

      <Block title="2. Your account">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>You are responsible for keeping your password confidential.</li>
          <li>You must not share your account or impersonate another delegate.</li>
          <li>We may suspend accounts that breach these terms or our Code of Conduct.</li>
        </ul>
      </Block>

      <Block title="3. Acceptable use">
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-1.5 mt-2">
          <li>Post abusive, defamatory, discriminatory or unlawful content in Q&amp;A, polls or messages.</li>
          <li>Share patient-identifiable information or other confidential clinical data.</li>
          <li>Send unsolicited commercial messages or use networking for spam.</li>
          <li>Attempt to gain unauthorised access to other accounts, the API or admin tooling.</li>
          <li>Scrape, reverse engineer, or otherwise misuse the App.</li>
        </ul>
      </Block>

      <Block title="4. Code of Conduct">
        <p>
          All in-app interactions are governed by the DFTB26 Code of Conduct, available on the Info page. Violations may
          result in immediate suspension of your account and removal from the conference.
        </p>
      </Block>

      <Block title="5. Medical disclaimer">
        <p>
          Content shown in the App - including session abstracts, speaker materials, audience questions and polls - is
          provided for educational purposes only. It is <strong>not medical advice</strong> and must not be relied upon
          for clinical decisions about specific patients. Always exercise independent professional judgement.
        </p>
      </Block>

      <Block title="6. User content">
        <p>
          You retain ownership of the content you submit (questions, poll votes, profile, messages). You grant DFTB a
          non-exclusive, royalty-free licence to host and display that content as needed to operate the App during and
          shortly after the conference.
        </p>
      </Block>

      <Block title="7. Service availability">
        <p>
          We work hard to keep the App available throughout DFTB26 but we do not guarantee uninterrupted service. We may
          add, remove or change features at any time.
        </p>
      </Block>

      <Block title="8. Limitation of liability">
        <p>
          To the maximum extent permitted by law, DFTB is not liable for indirect, incidental, or consequential damages
          arising from your use of the App. Nothing in these terms limits liability for death, personal injury caused by
          negligence, or fraud.
        </p>
      </Block>

      <Block title="9. Termination">
        <p>
          You may delete your account at any time by emailing{" "}
          <a href={`mailto:${CONTACT}`} className="text-[#000000] hover:underline">{CONTACT}</a>. We may suspend or
          terminate accounts that breach these terms.
        </p>
      </Block>

      <Block title="10. Governing law">
        <p>
          These terms are governed by the laws of England and Wales, and the courts of England and Wales have exclusive
          jurisdiction.
        </p>
      </Block>

      <Block title="11. Contact">
        <p>
          Don&apos;t Forget The Bubbles Ltd -{" "}
          <a href={`mailto:${CONTACT}`} className="text-[#000000] hover:underline">{CONTACT}</a>
        </p>
      </Block>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section className="p-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm">
      <h2 className="font-display text-lg mb-2">{title}</h2>
      <div className="text-sm text-[#5a5a5a] leading-relaxed">{children}</div>
    </section>
  );
}
